import _ from "lodash";
import {
  FETCH_FAILED,
  FETCH_WIDGET_DATA,
  PUSH_NOTIFICATION,
  REMOVE_MESSAGE,
  UPDATE_WIDGET_DATA,
  UPDATE_WIDGET_FROM_TO_DATES
} from "../actions/types";

import moment from "moment";

moment.suppressDeprecationWarnings = true;

export default function(
  state = {
    widgetFromToDate: {
      fromDate:
        moment()
          .subtract(7, "days")
          .format("MM/DD/YYYY") + " 12:00 AM",
      fromDateISO: moment()
        .subtract(7, "days")
        .toISOString(false),
      toDate: moment().format("L") + " 11:59 PM",
      toDateISO: moment().toISOString(false),
      refresh: 0,
      checkedAutoReload: false
    },
    isFetchingData: true
  },
  action
) {
  switch (action.type) {
    case FETCH_FAILED:
      return {
        ...state,
        data: {},
        isFetchingData: false
      };
    case FETCH_WIDGET_DATA:
      return {
        ...state,
        data: action.payload,
        isFetchingData: false
      };
    case UPDATE_WIDGET_DATA:
      return {
        ...state,
        updatedMissingUtterances: _.extend({}, action.payload.response, { data: action.payload.data })
      };
    case UPDATE_WIDGET_FROM_TO_DATES:
      return {
        ...state,
        widgetFromToDate: _.extend({}, state.widgetFromToDate, action.payload)
      };
    default:
      return state;
  }
}
